import { Send } from 'lucide-react';
type Props = {
  hasTelegram: boolean;
  clientLabel?: string;
};

export function CrmSalesStageIntro({ hasTelegram, clientLabel }: Props) {
  return (
    <div
      className="rounded-xl p-3 space-y-1.5"
      style={{ background: 'rgba(99,179,237,0.08)', border: '1px solid rgba(99,179,237,0.22)' }}
    >
      <p className="text-[11px] font-bold flex items-center gap-1.5" style={{ color: '#63B3ED' }}>
        <Send size={13} />
        Этап воронки (сделка)
      </p>
      <p className="text-[10px] leading-relaxed" style={{ color: 'var(--text-2)' }}>
        Выберите группу ниже. После чипа — лист с галочкой «Telegram»
        {clientLabel ? ` ${clientLabel}` : ''}. Это не то же самое, что статус «В производстве» в блоке
        «Операции».
      </p>
      {!hasTelegram && (
        <p className="text-[10px] font-bold" style={{ color: '#F6AD55' }}>
          У клиента нет Telegram ID — уведомление в бот не уйдёт. Позвоните или укажите ID в профиле.
        </p>
      )}
    </div>
  );
}
